// extracted by mini-css-extract-plugin
module.exports = {"button":"ClearSearchButton_button__uhdbI"};